export const createAccountView = 'create';
export const forgotPasswordView = 'forgot-password';
export const loginView = 'login';
